import React, {useState} from 'react';
import {validateCategorie } from '../../utils/validation';
import {initialCategorFormData} from '../../utils/formData';

function CategorieForm() {
    const [errors, setErrors] = useState({});
    const [formData, setFormData] = useState(initialCategorFormData);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
        ...formData,
        [name]: value,
        });
    };
    const validateFields = () => {
            let newErrors = {};
    

            newErrors = validateCategorie(formData);
            
    
            setErrors(newErrors);
            return Object.keys(newErrors).length === 0;
        };

        const handleSubmit = (e) => {
            e.preventDefault();
            if (validateFields()) {
            alert('Formulaire envoyé avec succès');
            }
        };

  return (
    <div className="inscription-container">
      <form onSubmit={handleSubmit} className='inscription-form'>
        <div className="form-step">
            <h2 className='inscription-title'>Ajouter une catégorie</h2>
            <div className="form-row">
                <div className="form-group">
                    <label>Nom de la categorie</label>
                    <input type="text" name="name" value={formData.name} onChange={handleChange} placeholder="Entrez le Nom du structure...." />
                    {errors.name && <p className="error">{errors.name}</p>}
                </div>
            </div>
          </div>
        

        <button type="submit" className="submit-button">
            Enregistrer
        </button>

      </form>
    </div>
  )
}

export default CategorieForm